module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "搜索"
    },
    model: {
      value: (_vm.filters.q),
      callback: function($$v) {
        _vm.$set(_vm.filters, "q", $$v)
      },
      expression: "filters.q"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getList
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.listdata,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', {
          style: ({
            color: row.Statclr
          })
        }, [_vm._v(_vm._s(row.Stats))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "金额",
      "align": "center",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', {
          staticClass: "wxmpTit"
        }, [(row.Isbank > 0) ? _c('el-button', {
          staticStyle: {
            "margin-right": "15px"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.$refs.txTaxTips.show(row.Imgs)
            }
          }
        }, [_vm._v("转账信息")]) : _c('img', {
          attrs: {
            "src": row.Imgsrc
          }
        }), _vm._v(" "), _c('span', {
          staticStyle: {
            "color": "#f60",
            "font-weight": "bold"
          }
        }, [_vm._v(_vm._s(row.Amounts))])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Timestr",
      "label": "申请时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Desc",
      "label": "描述"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Nickup",
      "label": "处理人",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Timeupstr",
      "label": "处理时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Remark",
      "label": "备注"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-button-group', [(row.Stat == 0) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.revokeBackFun(row)
            }
          }
        }, [_vm._v("撤回")]) : _vm._e()], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.filters.page,
      "total": _vm.total,
      "page-size": _vm.limit
    },
    on: {
      "update:currentPage": function($event) {
        return _vm.$set(_vm.filters, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.filters, "page", $event)
      },
      "current-change": _vm.getList
    }
  }), _vm._v(" "), _c('txTaxTips', {
    ref: "txTaxTips"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a47fd5f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ruis/user/TxList.vue
// module id = 1174
// module chunks = 1